'use client'
import { useState } from 'react'
import { Check, Copy } from 'lucide-react'

export function PromptCopyButton({ text }: { text: string }) {
  const [copied, setCopied] = useState(false)

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(text)
      setCopied(true)
      window.setTimeout(() => setCopied(false), 1500)
    } catch {
      // Browser blocked clipboard; do nothing.
    }
  }

  return (
    <button
      type="button"
      onClick={handleCopy}
      className="mt-3 inline-flex items-center gap-1.5 rounded-md border px-2.5 py-1.5 text-xs font-medium transition hover:border-primary/40 hover:bg-secondary"
    >
      {copied ? (
        <>
          <Check className="h-3 w-3 text-primary" /> Copied
        </>
      ) : (
        <>
          <Copy className="h-3 w-3" /> Copy prompt
        </>
      )}
    </button>
  )
}
